import { type Action, type ActionReducer, type MetaReducer } from '@ngrx/store';

import { type EngineStateBase, runtimeActions } from '@blaze-runtime/engine-data-access';
import { sentryLog } from '@blaze-shared/logger-util';
import { isElementSchema } from '@blaze-shared/schema-domain';
import { isDeepEqual } from '@blaze-shared/shared-util';

import { isAction } from './utils/is-action';

export const createEngineMetaReducer =
  (schemaValidationEnabled: boolean): MetaReducer<EngineStateBase> =>
  (
    reducer: ActionReducer<EngineStateBase, Action<string>>,
  ): ActionReducer<EngineStateBase, Action<string>> => {
    return (state, action) => {
      if (!state) {
        return reducer(state, action);
      }
      if (!schemaValidationEnabled) {
        return reducer(state, action);
      }
      if (!isAction(action, runtimeActions.storeRuntimeElementSchema)) {
        return reducer(state, action);
      }

      const currentSchema = state.schemas[action.schema.id];
      if (currentSchema && state.runtimeMode !== 'editor' && isElementSchema(currentSchema)) {
        if (!isDeepEqual(currentSchema, action.schema)) {
          sentryLog('Schema has changed in preview mode', 'warning', {
            jsonPayload: {
              currentSchema,
              newSchema: action.schema,
            },
          });
        }
      }

      return reducer(state, action);
    };
  };
